import {GameXpState} from '../../reducers/fortnite-game/gameXp.reducer';

export const getGameXpState = (state): GameXpState => {
    return state.get('gameXp').toJS();
};
